import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';
import { TABLE_VIEW_OPTIONS } from '../../shared/options/table-view-options';
import { SearchTableSortingHeader } from '../../shared/model/search-table-sorting-header';
import { SearchUrlParameters } from '../../shared/model/search-url-parameters';
import { SearchParams } from '../../api/models/search-params';
import { SORTING_OPTIONS } from '../../shared/options/sorting-options';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../shared/service/loader.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
})
export class SearchResultsComponent implements OnChanges, OnInit, OnDestroy {
  @Input()
  searchResult?: SearchResult;

  @Input()
  searchParams: SearchUrlParameters = {};

  isLoading = true;

  private loaderSubscription?: Subscription;

  tableModeAvailable = false;
  firstResourceType?: string;
  tableHeaders?: SearchTableSortingHeader[];
  instrumentDriverPage: boolean = false;

  constructor(
    private readonly loaderService: LoaderService,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loaderSubscription = this.loaderService.loaderObserver.subscribe(show => (this.isLoading = show));
    this.activatedRoute.queryParamMap.subscribe(qpm => {
      const snExists = qpm.has('sn');
      const sn = qpm.get('sn');
      this.instrumentDriverPage = (snExists && sn && sn.includes('catnav:sup.dwl.idr')) || false;
    });
  }

  ngOnDestroy() {
    if (this.loaderSubscription) {
      this.loaderSubscription?.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchResult'] && this.searchResult && this.searchResult.searchResultList) {
      this.tableModeAvailable = TABLE_VIEW_OPTIONS.some(
        opt => opt.facetCode === this.searchResult?.lastSelectedCategoryFacetCode
      );
      if (this.tableModeAvailable) {
        this.firstResourceType = this.searchResult.searchResultList[0]?.resourceType;
        this.tableHeaders = this.getTableHeaders();
      }
    }
  }

  private getTableHeaders(): SearchTableSortingHeader[] {
    const tableHeadersConfig =
      TABLE_VIEW_OPTIONS.find(opt => opt.facetCode === this.searchResult?.lastSelectedCategoryFacetCode)
        ?.tableHeaders || [];
    return tableHeadersConfig.map(headerConfig => {
      let currentOrder;
      let params: SearchParams | undefined = undefined;
      let sortingField;
      if (headerConfig.sortable) {
        const sb = this.searchParams.sb;
        params = { ...this.searchParams };
        if (!sb || (sb !== headerConfig.sortingOption1 && sb !== headerConfig.sortingOption2)) {
          params.sb = headerConfig.sortingOption1;
          currentOrder = 'default';
        } else if (sb === headerConfig.sortingOption1) {
          params.sb = headerConfig.sortingOption2;
          currentOrder = headerConfig.sortingOption1?.includes('+') ? 'asc' : 'desc';
        } else {
          params.sb = this.getDefaultSortingParameterForFacet(this.searchResult?.lastSelectedCategoryFacetCode);
          currentOrder = headerConfig.sortingOption2?.includes('+') ? 'asc' : 'desc';
        }
        sortingField = headerConfig.sortingOption1?.substr(1);
      }
      return {
        displayKey: headerConfig.key,
        currentOrder: currentOrder,
        sortingField: sortingField,
        params: params,
      } as SearchTableSortingHeader;
    });
  }

  private getDefaultSortingParameterForFacet(facetCode: string | undefined): string | undefined {
    const sortingOption = SORTING_OPTIONS.find(opt => opt.code === facetCode);
    if (sortingOption) {
      return sortingOption.sortingFields.find(field => field.isDefaultField)?.field;
    }
    return undefined;
  }
}
